import { render } from "./ProjectTagPage.vue?vue&type=template&id=34ab6516"
import script from "./ProjectTagPage.vue?vue&type=script&lang=js"
export * from "./ProjectTagPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__